import React, { useState, useContext, useEffect } from "react";

import "./LoginPage.css";

import { useNavigate } from "react-router-dom";

import Cookies from "js-cookie";

import { Context } from "../../../utils/context";

import LoginLottie from "./LoginLottie";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { getData } from "../../../utils/api";

const LoginPage = () => {
  const { postData, signin, setSignin, usertype, setUsertype, IMG_URL } =
    useContext(Context);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // ---------------- VALIDATION ----------------

  const validateForm = () => {
    let validationErrors = {};

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (!formData.email.trim()) {
      validationErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email.trim())) {
      validationErrors.email = "Enter a valid email address";
    }

    if (!formData.password.trim()) {
      validationErrors.password = "Password is required";
    }

    return validationErrors;
  };

  // ---------------- INPUT CHANGE ----------------

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear only the error for the field being edited
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // ---------------- LOGIN SUBMIT ----------------

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await postData("/common/auth/admin-login", formData);

      if (response.success) {
        setErrors({});

        setSignin(response.success);

        setUsertype(response?.data?.role);

        Cookies.set("ollypetshop_admin_security", response.data?.token, {
          expires: 365,
        });

        if (response?.data?.role === "demo") {
          navigate("/demo");
        } else if (response?.data?.role?.length) {
          navigate("/advanceDashboard");
        }
      } else {
        /*
         * IMPORTANT:
         * Backend errors are assigned according to the
         * actual error message.
         *
         * "User not found" -> Email field
         * "Incorrect password" -> Password field
         */

        const apiError = response?.errors || response?.message || "";

        const errorMessage = String(apiError).toLowerCase();

        if (
          errorMessage.includes("user not found") ||
          errorMessage.includes("user does not exist") ||
          errorMessage.includes("email not found") ||
          errorMessage.includes("email does not exist") ||
          errorMessage.includes("invalid email")
        ) {
          setErrors({
            email: apiError || "User not found",
          });
        } else if (
          errorMessage.includes("incorrect password") ||
          errorMessage.includes("wrong password") ||
          errorMessage.includes("password is incorrect") ||
          errorMessage.includes("invalid password")
        ) {
          setErrors({
            password: apiError || "Incorrect password",
          });
        } else {
          /*
           * If backend gives an unknown login error,
           * don't automatically put it under password.
           *
           * Put it under email because the login credential
           * itself could not be verified.
           */
          setErrors({
            email: apiError || "Unable to login",
          });
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);

      setErrors({
        email: "Unable to login. Please try again.",
      });
    }
  };

  // ---------------- ERROR STYLE ----------------

  const errorStyle = {
    color: "#d64545",
    marginLeft: "2px",
    display: "block",
    marginTop: "5px",
    marginBottom: "10px",
    fontSize: "14px",
  };

  // ---------------- APP SETUP ----------------

  const [appSetup, setAppSetup] = useState({});

  const GetAppSetup = async () => {
    const response = await getData(`/common/masters/app-setup`);

    if (response?.success) {
      setAppSetup(response?.data);
    }
  };

  useEffect(() => {
    GetAppSetup();
  }, []);

  // ---------------- UI ----------------

  return (
    <>
      <section className="Login">
        <div className="container-fluid p-0">
          <div className="row align-items-center justify-content-center">
            {/* CENTERED LOGIN FORM */}

            <div className="col-12 login-form-col">
              <div className="card text-center login-card">
                <div className="login-logo">
                  <img className="success" src={IMG_URL + appSetup?.logo} />
                </div>
                <div className="text-holder-login">
                  <h2 className="text-start heading_text">Welcome Back</h2>

                  <p className="text-start mt-4">
                    Enter your details to sign in to your admin account
                  </p>

                  <form onSubmit={handleSubmit} role="form">
                    {/* ================= EMAIL ================= */}

                    <div className="text-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="email_txt form-label"
                      >
                        Email ID
                      </label>
                    </div>

                    <div className="form-control-email">
                      <input
                        type="email"
                        className="form-control inputForm"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        placeholder="Enter Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>

                    {/* EMAIL ERROR */}

                    {errors.email && (
                      <span style={errorStyle}>{errors.email}</span>
                    )}

                    {/* ================= PASSWORD ================= */}

                    <div className="text-start">
                      <label
                        htmlFor="exampleInputPassword1"
                        className="email_txt form-label"
                      >
                        Password
                      </label>
                    </div>

                    <div className="form-control-email input-group password_section">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control inputForm"
                        id="exampleInputPassword1"
                        placeholder="Password"
                        aria-label="Password"
                        aria-describedby="basic-addon2"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                      />

                      <FontAwesomeIcon
                        icon={showPassword ? faEye : faEyeSlash}
                        className="formPasword"
                        onClick={togglePasswordVisibility}
                      />
                    </div>

                    {/* PASSWORD ERROR */}

                    {errors.password && (
                      <span style={errorStyle}>{errors.password}</span>
                    )}

                    {/* ================= DUMMY INPUT ================= */}

                    <input
                      className="form-control dummy_input"
                      placeholder="dummy"
                    />

                    {/* ================= LOGIN BUTTON ================= */}

                    <button
                      type="submit"
                      className="btn sign-in-button text-center"
                    >
                      Login
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LoginPage;
